export default "__VITE_ASSET__cfa2d646__"